import { useEffect, useRef } from 'react';

// Enhanced useAutoFocus hook that supports SELECT elements and conditional focusing
const useExpirationTimeSelectAutoFocus = (shouldFocus: boolean) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shouldFocus) {
      // Use the same pattern as useAutoFocus but for SELECT elements
      const selectElement = ref.current?.querySelector<HTMLSelectElement>(
        'select:not([disabled]):not([hidden])',
      );
      // Use the same timeout pattern as the original useAutoFocus
      setTimeout(() => {
        selectElement?.focus();
      });
    }
  }, [shouldFocus]);

  return { ref };
};

export default useExpirationTimeSelectAutoFocus;
